import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {useSelector} from "react-redux";
import useSlider from "./useSlider";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';

export default function () {
  const {sliderFields, handleSubmit, setData, setErrors} = useSlider();
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    axios.get('sliders/create').then(res => {
      setData(res.data.data);
    });
  }, []);

  const addSlider = data => {
    axios.post('sliders', data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Slider has been created successfully!', {
            icon: "success",
          });
          navigate("/sliders");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  return (
    <Card title="Add slider">
      <form className="form w-100 row" onSubmit={handleSubmit(addSlider)}>
        {sliderFields}
        <SubmitButton
          title="Add"
          classes="w-auto d-inline-block float-right mt-4"
        />
      </form>
    </Card>
  );
}